











import { defineComponent } from '@vue/composition-api';
import VehiclePopoverCell from '@/components/Comparison/VehiclePopoverCell.vue';

export default defineComponent({
    name: 'InsuranceCell',
    components: { VehiclePopoverCell },
    props: {
        id: { type: Number, required: true },
        insurance: { type: String, required: true },
        callout: { type: String, default: '' },
        link: { type: String, default: '' }
    }
});
